
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"30","height":"31","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M28.636 0C29.39 0 30 .621 30 1.388v27.758c0 .766-.61 1.388-1.364 1.388H1.364A1.376 1.376 0 010 29.146V1.388C0 .62.61 0 1.364 0h27.272zm-9.758 17.288c-1.243.78-2.462 2.294-2.895 3.375l2.829 3.348 2.82-2.086-2.754-4.637zm4.04-6.141c-6.453.742-11.945 4.725-14.883 10.317l3.881 2.542c2.325-4.827 6.764-8.402 12.084-9.469l-1.081-3.39zm-6.177-4.59h-3.487l-.49 5.938-5.688-1.363L6 14.512l3.949 1.698c.81-.834 1.714-1.561 2.71-2.183 1.347-.843 2.524-1.401 4.525-2.1l-.443-5.37z","fill":"#FFF","fill-rule":"evenodd"}})])
      }
    
      }
    